// --- スマートフォン用追従ボタンの表示制御 --- START
document.addEventListener('DOMContentLoaded', () => {
    // console.log('Sticky buttons script loaded and DOMContentLoaded.');
    const stickyButtonsContainer = document.querySelector('.ufit-sticky-buttons-container');
    const scrollTopBtn = document.querySelector('.ufit-scroll-top-btn');

    if (!stickyButtonsContainer) {
        // console.log('Sticky buttons container not found.'); 
        return;
    }
    // console.log('Sticky buttons container found:', stickyButtonsContainer);

    const scrollThreshold = 300; // ボタンを表示するスクロール量の閾値 (px)
    const mobileMaxWidth = 768; // モバイルと判定する最大幅 (px)
    let isScrolling = false;
    let resizeTimeout;

    // 表示状態を更新する関数
    const updateButtonVisibility = () => {
        const scrollY = window.scrollY;
        const isMobile = window.innerWidth <= mobileMaxWidth;

        // console.log('Updating visibility: scrollY:', scrollY, 'isMobile:', isMobile);

        if (isMobile && scrollY > scrollThreshold) {
            stickyButtonsContainer.classList.add('is-visible');
            // console.log('Container should be visible.');
        } else {
            stickyButtonsContainer.classList.remove('is-visible');
            // console.log('Container should be hidden.');
        }
    };

    // スクロールイベントのハンドラ（スロットリング）
    const handleScroll = () => {
        if (!isScrolling) {
            window.requestAnimationFrame(() => {
                updateButtonVisibility(); // 表示更新関数を呼び出す
                isScrolling = false;
            });
            isScrolling = true;
        }
    };

    // リサイズイベントのハンドラ（デバウンス）
    const handleResize = () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            // console.log('Resize event detected. Updating visibility.');
            updateButtonVisibility(); // 表示更新関数を呼び出す
        }, 150); // 150ms待ってから実行
    };

    // ページトップへ戻るボタンのクリックイベント
    if (scrollTopBtn) {
        // console.log('Scroll top button found:', scrollTopBtn);
        scrollTopBtn.addEventListener('click', () => {
            // console.log('Scroll top button clicked.'); 
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        });
    } else {
        // console.log('Scroll top button not found.');
    }

    // イベントリスナーを追加
    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleResize);
    // console.log('Scroll and resize event listeners added.');

    // 初期表示チェック
    updateButtonVisibility();
    // console.log('Initial visibility check done.'); 
});
// --- スマートフォン用追従ボタンの表示制御 --- END 